import React, { ReactNode, CSSProperties, useMemo } from 'react'
import clsx from 'clsx'
import { Label, LabelType } from 'components/Label'

import styles from './Folder.module.scss'

interface FolderProps {
  title: string
  color?: 'red' | 'mint' | 'grey'
  locked?: boolean
  shadowColor?: string
  childrenBackgroundColor?: string
  style?: CSSProperties
  children?: ReactNode
  className?: string
}

function Folder({
  children,
  title,
  className,
  color = 'grey',
  shadowColor = '#ddd',
  locked,
  childrenBackgroundColor = '#fff',
  style
}: FolderProps) {
  const colorScheme = useMemo(() => {
    switch (color) {
      case 'red':
        return {
          primary: '#cc0a5a',
          secondary: '#f76988'
        }

      case 'mint':
        return {
          primary: '#00A1AA',
          secondary: '#26d4dd'
        }

      default:
        return {
          primary: '#c8c8c8',
          secondary: '#ffffff'
        }
    }
  }, [color])

  return (
    <div
      className={clsx(styles.mainContainer, className)}
      style={{
        backgroundColor: colorScheme.primary,
        ...style
      }}
    >
      <div className={styles.container}>
        <div
          className={styles.header}
          style={{
            backgroundColor: colorScheme.primary
          }}
        >
          <div
            className={styles.titleBackground}
            style={{
              backgroundColor: colorScheme.secondary
            }}
          >
            <div
              className={styles.titleWrapper}
              style={{
                backgroundColor: colorScheme.primary
              }}
            >
              {locked && (
                <div className={styles.label}>
                  <Label type={LabelType.LOCK} large />
                </div>
              )}
              <span className={styles.title}>{title}</span>
            </div>
          </div>
          <div
            className={styles.filler}
            style={{
              backgroundColor: colorScheme.secondary
            }}
          />
        </div>
        <div
          className={styles.paddingBackground}
          style={{
            backgroundColor: colorScheme.secondary
          }}
        >
          <div
            className={styles.padding}
            style={{
              backgroundColor: colorScheme.primary
            }}
          />
        </div>
        <div
          className={styles.childrenContainer}
          style={{
            backgroundColor: childrenBackgroundColor
          }}
        >
          {children}
        </div>
      </div>
      <div
        className={styles.shadow}
        style={{
          backgroundColor: shadowColor
        }}
      />
    </div>
  )
}

export default Folder
